<ul class="ultima-menu ultima-main-menu clearfix"><li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li></ul>